import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-download",
  templateUrl: "./med-icon-download.component.html",
})
export class MedIconDownloadComponent extends SvgMixinComponent {}
